export default function registration() {
    const formReg = document.querySelector('.js-form-reg');   

    if (formReg) {
        const passInput = formReg.querySelector('input[name="reg-pass"]');
        const confirmPassInput = formReg.querySelector('input[name="reg-confirm-pass"]');
        
        // Функция проверки совпадения паролей
        function validatePasswords() {
            if (passInput.value !== confirmPassInput.value) {
                confirmPassInput.setCustomValidity('Пароли не совпадают');
                return false;
            } else {
                confirmPassInput.setCustomValidity('');
                return true;
            }
        }

        // Проверка при вводе
        [passInput, confirmPassInput].forEach(input => {
            input.addEventListener('input', function() {
                this.setCustomValidity('');
                validatePasswords();
            });
        });

        // Проверка при отправке формы
        formReg.addEventListener('submit', function(e) {
            if (!validatePasswords()) {
                e.preventDefault();
                confirmPassInput.reportValidity();
            }
        });
    }
}